import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { GreeningDisclaimer } from './GreeningDisclaimer';
import { GreeningAgentSignature } from './GreeningAgentSignature';
import { GreeningOaasCta } from './GreeningOaasCta';

interface Props {
  compact?: boolean;
  showOaasCta?: boolean;
}

/** Rodapé padrão de respostas AI Greening: disclaimer + CTA OaaS (condicional) + assinatura. */
export function GreeningResponseFooter({ compact, showOaasCta }: Props) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mt: compact ? 1 : 1.5,
        pt: compact ? 1 : 1.5,
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        component="div"
        sx={{ fontStyle: 'italic', mb: 0.75 }}
      >
        <GreeningDisclaimer />
      </Typography>
      {showOaasCta && <GreeningOaasCta compact={compact} />}
      <Typography
        variant="caption"
        color="text.secondary"
        component="div"
        sx={{ fontStyle: 'italic', mt: showOaasCta ? 0.75 : 0 }}
      >
        <GreeningAgentSignature />
      </Typography>
    </Box>
  );
}

export default GreeningResponseFooter;
